<template>
  <div class="inputo flex items-center pl-2" :style="{ 'height': height, 'border': border, 'border-radius': radius, 'background-color': background }">
    <v-date-picker
      class="inline-block h-full"
      v-model="startDate"
      :min-date="minDate"
      :max-date="maxDate"
      :placeholder="startPlaceholder"
    >
      <template #default="{ inputValue, togglePopover }">
        <div class="flex items-center h-full">
          <button class="p-2 hover:bg-blue-200 text-blue-600 rounded-l focus:bg-blue-500 focus:text-white focus:border-blue-500 focus:outline-none" @click="togglePopover()">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" class="w-4 h-4 fill-current">
              <path d="M1 4c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z" />
            </svg>
          </button>
          <input :value="inputValue" class="bg-white text-c16 w-full appearance-none focus:outline-none ml-2" :placeholder="startPlaceholder" readonly @click="togglePopover()">
        </div>
      </template>
    </v-date-picker>

    <v-date-picker
      class="inline-block h-full ml-2"
      v-model="endDate"
      :min-date="minDate"
      :max-date="maxDate"
      :placeholder="endPlaceholder"
    >
      <template #default="{ inputValue, togglePopover }">
        <div class="flex items-center h-full">
          <input :value="inputValue" class="bg-white text-c16 w-full appearance-none focus:outline-none ml-2" :placeholder="endPlaceholder" readonly @click="togglePopover()">
        </div>
      </template>
    </v-date-picker>

    {{ formattedDateRange }}
  </div>
</template>

<script>
export default {
  name: 'DateRangePicker',

  props: {
    minDate: { type: String, default: null },
    maxDate: { type: String, default: null },
    startPlaceholder: { type: String, default: 'Date de début' },
    endPlaceholder: { type: String, default: 'Date de fin' },
    height: { type: String, default: '40px' },
    border: { type: String, default: '1px solid #DCDCE4' },
    radius: { type: String, default: '4px' },
    background: { type: String, default: 'white' }
  },

  data() {
    return {
      startDate: null,
      endDate: null
    };
  },

  computed: {
    formattedDateRange() {
      if (this.startDate && this.endDate) {
        return `${this.startDate} - ${this.endDate}`;
      }
      return '';
    }
  },

  watch: {
    startDate(newVal) {
      this.$emit('update:startDate', newVal);
    },
    endDate(newVal) {
      this.$emit('update:endDate', newVal);
    }
  }
};
</script>

<style scoped>
.inputo {
  display: flex;
  align-items: center;
}
</style>
